(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197,527],{

/***/ 3420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9704)


/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(8742);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(150);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(3420);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(1228);
;// CONCATENATED MODULE: ./node_modules/color2k/dist/index.exports.import.es.mjs
/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */
function guard(low, high, value) {
  return Math.min(Math.max(low, value), high);
}

class ColorError extends Error {
  constructor(color) {
    super(`Failed to parse color: "${color}"`);
  }

}

var ColorError$1 = ColorError;

/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */

function parseToRgba(color) {
  if (typeof color !== 'string') throw new ColorError$1(color);
  if (color.trim().toLowerCase() === 'transparent') return [0, 0, 0, 0];
  let normalizedColor = color.trim();
  normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
  const reducedHexMatch = reducedHexRegex.exec(normalizedColor);

  if (reducedHexMatch) {
    const arr = Array.from(reducedHexMatch).slice(1);
    return [...arr.slice(0, 3).map(x => parseInt(r(x, 2), 16)), parseInt(r(arr[3] || 'f', 2), 16) / 255];
  }

  const hexMatch = hexRegex.exec(normalizedColor);

  if (hexMatch) {
    const arr = Array.from(hexMatch).slice(1);
    return [...arr.slice(0, 3).map(x => parseInt(x, 16)), parseInt(arr[3] || 'ff', 16) / 255];
  }

  const rgbaMatch = rgbaRegex.exec(normalizedColor);

  if (rgbaMatch) {
    const arr = Array.from(rgbaMatch).slice(1);
    return [...arr.slice(0, 3).map(x => parseInt(x, 10)), parseFloat(arr[3] || '1')];
  }

  const hslaMatch = hslaRegex.exec(normalizedColor);

  if (hslaMatch) {
    const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
    if (guard(0, 100, s) !== s) throw new ColorError$1(color);
    if (guard(0, 100, l) !== l) throw new ColorError$1(color);
    return [...hslToRgb(h, s, l), a || 1];
  }

  throw new ColorError$1(color);
}

function hash(str) {
  let hash = 5381;
  let i = str.length;

  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }
  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */


  return (hash >>> 0) % 2341;
}

const colorToInt = x => parseInt(x.replace(/_/g, ''), 36);

const compressedColorMap = '1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm'.split(' ').reduce((acc, next) => {
  const key = colorToInt(next.substring(0, 3));
  const hex = colorToInt(next.substring(3)).toString(16); // NOTE: padStart could be used here but it breaks Node 6 compat
  // https://github.com/ricokahler/color2k/issues/351

  let prefix = '';

  for (let i = 0; i < 6 - hex.length; i++) {
    prefix += '0';
  }

  acc[key] = `${prefix}${hex}`;
  return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */

function nameToHex(color) {
  const normalizedColorName = color.toLowerCase().trim();
  const result = compressedColorMap[hash(normalizedColorName)];
  if (!result) throw new ColorError$1(color);
  return `#${result}`;
}

const r = (str, amount) => Array.from(Array(amount)).map(() => str).join('');

const reducedHexRegex = new RegExp(`^#${r('([a-f0-9])', 3)}([a-f0-9])?$`, 'i');
const hexRegex = new RegExp(`^#${r('([a-f0-9]{2})', 3)}([a-f0-9]{2})?$`, 'i');
const rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r(',\\s*(\\d+)\\s*', 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, 'i');
const hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const namedColorRegex = /^[a-z]+$/i;

const roundColor = color => {
  return Math.round(color * 255);
};

const hslToRgb = (hue, saturation, lightness) => {
  let l = lightness / 100;

  if (saturation === 0) {
    // achromatic
    return [l, l, l].map(roundColor);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  const huePrime = (hue % 360 + 360) % 360 / 60;
  const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
  const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  let red = 0;
  let green = 0;
  let blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  const lightnessModification = l - chroma / 2;
  const finalRed = red + lightnessModification;
  const finalGreen = green + lightnessModification;
  const finalBlue = blue + lightnessModification;
  return [finalRed, finalGreen, finalBlue].map(roundColor);
};

// taken from:
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */

function parseToHsla(color) {
  const [red, green, blue, alpha] = parseToRgba(color).map((value, index) => // 3rd index is alpha channel which is already normalized
  index === 3 ? value : value / 255);
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  const lightness = (max + min) / 2; // achromatic

  if (max === min) return [0, 0, lightness, alpha];
  const delta = max - min;
  const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
  return [hue, saturation, lightness, alpha];
}

/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */

function hsla(hue, saturation, lightness, alpha) {
  return `hsla(${(hue % 360).toFixed()}, ${guard(0, 100, saturation * 100).toFixed()}%, ${guard(0, 100, lightness * 100).toFixed()}%, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
}

/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */

function adjustHue(color, degrees) {
  const [h, s, l, a] = parseToHsla(color);
  return hsla(h + degrees, s, l, a);
}

/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */

function darken(color, amount) {
  const [hue, saturation, lightness, alpha] = parseToHsla(color);
  return hsla(hue, saturation, lightness - amount, alpha);
}

/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */

function desaturate(color, amount) {
  const [h, s, l, a] = parseToHsla(color);
  return hsla(h, s - amount, l, a);
}

// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js

/**
 * Returns a number (float) representing the luminance of a color.
 */

function getLuminance(color) {
  if (color === 'transparent') return 0;

  function f(x) {
    const channel = x / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }

  const [r, g, b] = parseToRgba(color);
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}

// taken from:
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */

function getContrast(color1, color2) {
  const luminance1 = getLuminance(color1);
  const luminance2 = getLuminance(color2);
  return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}

/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */

function rgba(red, green, blue, alpha) {
  return `rgba(${guard(0, 255, red).toFixed()}, ${guard(0, 255, green).toFixed()}, ${guard(0, 255, blue).toFixed()}, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
}

/**
 * Mixes two colors together. Taken from sass's implementation.
 */

function mix(color1, color2, weight) {
  const normalize = (n, index) => // 3rd index is alpha channel which is already normalized
  index === 3 ? n : n / 255;

  const [r1, g1, b1, a1] = parseToRgba(color1).map(normalize);
  const [r2, g2, b2, a2] = parseToRgba(color2).map(normalize); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  const alphaDelta = a2 - a1;
  const normalizedWeight = weight * 2 - 1;
  const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
  const weight2 = (combinedWeight + 1) / 2;
  const weight1 = 1 - weight2;
  const r = (r1 * weight1 + r2 * weight2) * 255;
  const g = (g1 * weight1 + g2 * weight2) * 255;
  const b = (b1 * weight1 + b2 * weight2) * 255;
  const a = a2 * weight + a1 * (1 - weight);
  return rgba(r, g, b, a);
}

/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */

function getScale(...colors) {
  return n => {
    const lastIndex = colors.length - 1;
    const lowIndex = guard(0, lastIndex, Math.floor(n * lastIndex));
    const highIndex = guard(0, lastIndex, Math.ceil(n * lastIndex));
    const color1 = colors[lowIndex];
    const color2 = colors[highIndex];
    const unit = 1 / lastIndex;
    const weight = (n - unit * lowIndex) / unit;
    return mix(color1, color2, weight);
  };
}

const guidelines = {
  decorative: 1.5,
  readable: 3,
  aa: 4.5,
  aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */

function hasBadContrast(color, standard = 'aa', background = '#fff') {
  return getContrast(color, background) < guidelines[standard];
}

/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */

function lighten(color, amount) {
  return darken(color, -amount);
}

/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */

function transparentize(color, amount) {
  const [r, g, b, a] = parseToRgba(color);
  return rgba(r, g, b, a - amount);
}

/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */

function opacify(color, amount) {
  return transparentize(color, -amount);
}

/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */

function readableColorIsBlack(color) {
  return getLuminance(color) > 0.179;
}

/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */

function readableColor(color) {
  return readableColorIsBlack(color) ? '#000' : '#fff';
}

/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */

function saturate(color, amount) {
  return desaturate(color, -amount);
}

/**
 * Takes in any color and returns it as a hex code.
 */

function toHex(color) {
  const [r, g, b, a] = parseToRgba(color);

  let hex = x => {
    const h = guard(0, 255, x).toString(16); // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351

    return h.length === 1 ? `0${h}` : h;
  };

  return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ''}`;
}

/**
 * Takes in any color and returns it as an rgba string.
 */

function toRgba(color) {
  return rgba(...parseToRgba(color));
}

/**
 * Takes in any color and returns it as an hsla string.
 */

function toHsla(color) {
  return hsla(...parseToHsla(color));
}


//# sourceMappingURL=index.exports.import.es.mjs.map

;// CONCATENATED MODULE: ./hooks/useColorTheme.ts


function useColorTheme(primaryColor) {
    (0,react.useEffect)(()=>{
        if (primaryColor) {
            const root = document.documentElement;
            const readablecolor = readableColor(primaryColor);
            root.style.setProperty("--primary-500", primaryColor || "");
            root.style.setProperty("--primary-300", transparentize(primaryColor, 0.3) || "");
            root.style.setProperty("--primary-50", transparentize(primaryColor, 0.85) || "");
            // It's too weird, but the Design team can do it.
            if (primaryColor === "#536DFE") {
                root.style.setProperty("--primary-readable-color", "#ffffff");
            } else {
                root.style.setProperty("--primary-readable-color", readablecolor || "");
            }
        }
    }, [
        primaryColor
    ]);
    return;
}
/* harmony default export */ var hooks_useColorTheme = (useColorTheme);

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(154);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(7557);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(9861);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(4783);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs





function useIsFetching(arg1, arg2, arg3) {
  const [filters, options = {}] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const queryCache = queryClient.getQueryCache();
  return (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => queryCache.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [queryCache]), () => queryClient.isFetching(filters), () => queryClient.isFetching(filters));
}


//# sourceMappingURL=useIsFetching.mjs.map

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(8227);
;// CONCATENATED MODULE: ./hooks/useSpinner.ts



function useSpinner() {
    const isFetching = useIsFetching();
    (0,react.useEffect)(()=>{
        let toastId;
        if (isFetching) {
            toastId = dist/* toast.loading */.Am.loading("Fetching...", {
                position: "top-center"
            });
        }
        return ()=>{
            dist/* toast.dismiss */.Am.dismiss(toastId);
        };
    }, [
        isFetching
    ]);
}
/* harmony default export */ var hooks_useSpinner = (useSpinner);

;// CONCATENATED MODULE: ./utils/aes.utils.ts
const secretKey = "0f3e581733534ef19cdd753c3eac0937";
const cipher = (salt)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const byteHex = (n)=>("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return (text)=>text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};
const decipher = (salt)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return (encoded)=>encoded.match(/.{1,2}/g).map((hex)=>parseInt(hex, 16)).map(applySaltToChar).map((charCode)=>String.fromCharCode(charCode)).join("");
};
const encrypt = cipher(secretKey);
const decrypt = decipher(secretKey);
const generateOGUrl = (param)=>{
    let { title , primaryColor , logoURL  } = param;
    return encrypt(JSON.stringify({
        title,
        primaryColor,
        logoURL
    }));
};

// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./hooks/useSortWorkingHours.ts
var useSortWorkingHours = __webpack_require__(6349);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
;// CONCATENATED MODULE: ./containers/JSON-LD/JSON-LD.tsx






const DOMAIN_URL = "https://www.yocale.com";
const StoreJsonLd = ()=>{
    var _profile_phoneNumber, _profile_phoneNumber1;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const profile = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const location = profile === null || profile === void 0 ? void 0 : profile.locations.items[0].address;
    const workingHours = profile === null || profile === void 0 ? void 0 : profile.workingHours;
    const review = profile === null || profile === void 0 ? void 0 : profile.reviews.items;
    const service = profile === null || profile === void 0 ? void 0 : profile.services.items;
    const locations = profile === null || profile === void 0 ? void 0 : profile.locations.items;
    const images = profile === null || profile === void 0 ? void 0 : profile.coverImages.map((x)=>x.url);
    const description = (profile === null || profile === void 0 ? void 0 : profile.description) || t("sections.about.description");
    const sorting = (0,useSortWorkingHours/* default */.Z)(workingHours);
    const openingHours = (0,react.useMemo)(()=>sorting.filter((x)=>x.time[0]).map((x)=>({
                opens: x.time[0].start,
                closes: x.time[0].end,
                dayOfWeek: x.d
            })), [
        sorting
    ]);
    const reviews = (0,react.useMemo)(()=>{
        return review === null || review === void 0 ? void 0 : review.map((re)=>({
                author: "".concat(re.author.firstName, " ").concat(re.author.lastName),
                datePublished: re.publishedAt,
                reviewBody: re.comment,
                reviewRating: {
                    ratingValue: re.score
                }
            }));
    }, [
        review
    ]);
    const areas = (0,react.useMemo)(()=>{
        return locations === null || locations === void 0 ? void 0 : locations.map((loc)=>({
                geoMidpoint: {
                    latitude: loc.address.geoLocation.latitude,
                    longitude: loc.address.geoLocation.longitude
                },
                geoRadius: 1000
            }));
    }, [
        locations
    ]);
    const makesOffer = (0,react.useMemo)(()=>{
        return service === null || service === void 0 ? void 0 : service.map((se)=>{
            return {
                priceSpecification: {
                    type: "UnitPriceSpecification",
                    priceCurrency: profile === null || profile === void 0 ? void 0 : profile.currency.name,
                    price: "".concat(se.price)
                },
                itemOffered: {
                    name: se.name,
                    description: se.description
                }
            };
        });
    }, [
        profile === null || profile === void 0 ? void 0 : profile.currency.name,
        service
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, {
        type: "Store",
        id: "".concat(DOMAIN_URL, "/b/").concat(profile === null || profile === void 0 ? void 0 : profile.key),
        name: (profile === null || profile === void 0 ? void 0 : profile.name) || "",
        description: description || "",
        url: "".concat(DOMAIN_URL, "/b/").concat(profile === null || profile === void 0 ? void 0 : profile.key),
        telephone: "+".concat(profile === null || profile === void 0 ? void 0 : (_profile_phoneNumber = profile.phoneNumber) === null || _profile_phoneNumber === void 0 ? void 0 : _profile_phoneNumber.countryCode).concat((profile === null || profile === void 0 ? void 0 : (_profile_phoneNumber1 = profile.phoneNumber) === null || _profile_phoneNumber1 === void 0 ? void 0 : _profile_phoneNumber1.number) || ""),
        address: {
            streetAddress: location === null || location === void 0 ? void 0 : location.displayAddress,
            addressLocality: location === null || location === void 0 ? void 0 : location.city,
            addressRegion: location === null || location === void 0 ? void 0 : location.state,
            postalCode: location === null || location === void 0 ? void 0 : location.postalCode,
            addressCountry: location === null || location === void 0 ? void 0 : location.country
        },
        geo: {
            latitude: location === null || location === void 0 ? void 0 : location.geoLocation.latitude,
            longitude: location === null || location === void 0 ? void 0 : location.geoLocation.longitude
        },
        images: images,
        // sameAs={["www.company-website-url1.dev", "www.company-website-url2.dev", "www.company-website-url3.dev"]}
        openingHours: openingHours,
        rating: {
            ratingValue: "".concat(profile === null || profile === void 0 ? void 0 : profile.rate.score),
            ratingCount: "".concat(profile === null || profile === void 0 ? void 0 : profile.rate.count)
        },
        review: reviews,
        makesOffer: makesOffer,
        areaServed: areas
    });
};


// EXTERNAL MODULE: ./utils/utils.ts
var utils_utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./containers/Layout/Layout.tsx











const GTM_ID = "GTM-K9SZ2CD";
const Header = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(169), __webpack_require__.e(189)]).then(__webpack_require__.bind(__webpack_require__, 4189)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4189)
            ]
    },
    ssr: false
});
const Layout = (param)=>{
    let { children , businessKey , title , description , hideHeaderFooter , primaryColor , logoURL , headerProps , languages  } = param;
    hooks_useColorTheme(primaryColor);
    hooks_useSpinner();
    const cx = generateOGUrl({
        title,
        primaryColor,
        logoURL
    });
    const truncatedDesc = description && (0,utils_utils/* truncateString */.aS)(description, 160);
    const languageAlternates = (0,react.useMemo)(()=>{
        return languages === null || languages === void 0 ? void 0 : languages.map((l)=>({
                hrefLang: l,
                href: "".concat("https://www.yocale.com", "/b/").concat(l, "/").concat(businessKey)
            }));
    }, [
        languages,
        businessKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: (0,utils_utils/* resolvedPublicPath */.dO)("apple-touch-icon.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: (0,utils_utils/* resolvedPublicPath */.dO)("favicon-32x32.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: (0,utils_utils/* resolvedPublicPath */.dO)("favicon-16x16.png")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtag-base",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer', '".concat(GTM_ID, "');\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: truncatedDesc,
                canonical: "".concat("https://www.yocale.com", "/b/").concat(businessKey),
                noindex: "false" === "true",
                languageAlternates: languageAlternates,
                openGraph: {
                    url: "".concat("https://www.yocale.com", "/b/").concat(businessKey),
                    title,
                    description: truncatedDesc,
                    images: [
                        {
                            url: "".concat("https://og.planet.yocale.com", "/api/og?cx=").concat(cx),
                            width: 1200,
                            height: 630,
                            alt: title,
                            type: "image/png"
                        }
                    ]
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            !hideHeaderFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreJsonLd, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "text-black",
                children: [
                    !hideHeaderFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        ...headerProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "googletagmanager",
                            src: "https://www.googletagmanager.com/ns.html?id=".concat(GTM_ID),
                            height: "0",
                            width: "0",
                            style: {
                                display: "none",
                                visibility: "hidden"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Layout_Layout = (/*#__PURE__*/(0,react.memo)(Layout));


/***/ }),

/***/ 9350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FV": function() { return /* binding */ fetchBusinessProfile; },
  "jB": function() { return /* binding */ useBusinessProfile; },
  "yL": function() { return /* binding */ useProvider; },
  "DF": function() { return /* binding */ useReviews; },
  "Su": function() { return /* binding */ useServices; }
});

// UNUSED EXPORTS: fetchAllServices, fetchProviders, fetchReviews

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(6200);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(5347);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var lib_axios = __webpack_require__(5960);
;// CONCATENATED MODULE: ./lib/axios.ts

const ENDPOINT_URL = "https://planet.yocale.com";
const axios_axios = lib_axios/* default.create */.Z.create({
    baseURL: "".concat(ENDPOINT_URL, "/api/v1")
});

// EXTERNAL MODULE: ./queries/index.query.ts + 1 modules
var index_query = __webpack_require__(5866);
;// CONCATENATED MODULE: ./hooks/useFetch.ts



const PAGINATE_LIMIT = Number("10");
const fetchReviews = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/reviews?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchServices = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/services?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchProviders = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/providers?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchAllServices = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        offset: 0,
        limit: 0,
        hasNext: true,
        items: []
    }, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 50;
    const offset = pageParam * limit;
    return axios.get("/businesses/".concat(slug, "/services?offset=").concat(offset, "&limit=").concat(limit)).then((res)=>{
        console.log("Fetch All Services, Offset: ".concat(offset, " - Limit: ").concat(limit));
        data.items.push(...res.data.data.items);
        data.offset = res.data.data.offset;
        data.limit = res.data.data.limit;
        data.hasNext = res.data.data.hasNext;
        if (!res.data.data.hasNext) return data;
        return fetchAllServices(slug, pageParam + 1, data);
    });
};
const fetchBusinessProfile = async function(slug) {
    let fields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "services,providers,reviews,locations";
    const req = await axios_axios("/businesses/".concat(slug, "?fields=").concat(fields));
    return req.data;
};
const useBusinessProfile = ()=>{
    return (0,useQuery/* useQuery */.a)([
        index_query/* queries.publicProfile.businessKey */.o.publicProfile.businessKey
    ], {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false
    });
};
const useReviews = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "reviews"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchReviews(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return pages.length * PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};
const useServices = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "services"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchServices(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return pages.length * PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};
const useProvider = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "providers"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchProviders(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return (pages.length - 1) * PAGINATE_LIMIT + PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};



/***/ }),

/***/ 6349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1776);

const useSortWorkingHours = (workingHours)=>{
    const sorting = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (!workingHours) return [];
        const times = [];
        Object.entries(workingHours).forEach(function(param) {
            let [day, time] = param;
            times.push({
                d: day,
                time
            });
        });
        const sorter = {
            // "sunday": 0, // << if sunday is first day of week
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
            sunday: 7
        };
        times.sort((a, b)=>{
            let day1 = a.d.toLowerCase();
            let day2 = b.d.toLowerCase();
            return sorter[day1] - sorter[day2];
        });
        return times;
    }, [
        workingHours
    ]);
    return sorting;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSortWorkingHours);


/***/ }),

/***/ 8742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var containers_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5527);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8728);




const Custom404 = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__["default"], {
        title: "404",
        hideHeaderFooter: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "min-h-screen flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: (0,utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolvedPublicPath */ .dO)("404.svg"),
                    width: 649,
                    height: 433,
                    alt: "404",
                    priority: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-36",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: (0,utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolvedPublicPath */ .dO)("yocale-logo.svg"),
                        alt: "Powered by Yocale",
                        width: 100,
                        height: 48,
                        loading: "lazy"
                    })
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Custom404);


/***/ }),

/***/ 5866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ queries; }
});

// EXTERNAL MODULE: ./node_modules/@lukemorales/query-key-factory/dist/index.mjs
var dist = __webpack_require__(4967);
;// CONCATENATED MODULE: ./queries/businessProfile.query.ts

const businessProfileKeys = (0,dist/* createQueryKeys */.no)("publicProfile", {
    businessKey: null
});

;// CONCATENATED MODULE: ./queries/index.query.ts


const queries = (0,dist/* mergeQueryKeys */.kR)(businessProfileKeys);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ isProd; },
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; }
/* harmony export */ });
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(194);


const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    let link = "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier, "?lng=").concat(locale);
    switch(type){
        case "location":
            link += "&locations=".concat(id);
            break;
        case "provider":
            link += "&op=~".concat(id);
            break;
        case "service":
            link += "&op=".concat(id, "~");
            break;
        default:
            break;
    }
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>isProd() ? "/b/".concat(path) : "/".concat(path);
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label, fallback) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 13;
    if (!label) return fallback;
    return truncateString(label, limit);
};



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [574,832,564,774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);